import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ProjectContainer = styled.div`
    background-color: #F6F6F6;
    border-radius: 20px;
    border: 2px solid white;
    padding: 20px;
    margin: 20px 0;
    position:relative;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
`

const BesoinEditor = (props) => {

    const { i18n } = useTranslation('common');

    function addProjet(e){
        e.preventDefault()
        var newid = Math.random().toString(36).substr(2, 9);
        props.setProjets(oldArray => [...oldArray,{_id: newid ,userId: null,title: '',type:'', country:'', city:'' ,validated: false}])
    }

    function removeProjet(e,id){
        e.preventDefault()
        props.setDeletedProjets(oldArray => [...oldArray, id])
        props.setProjets(oldArray => oldArray.filter(proj => proj._id !== id))
    }

    function validateProject(e,projId){
        e.preventDefault()
        let _projets = [...props.projets]
        for(let i=0;i<_projets.length;i++){
            if(_projets[i]._id === projId){

                if(
                    _projets[i].title === '' ||
                    _projets[i].type === '' ||
                    _projets[i].country === '' ||
                    _projets[i].city === ''
                ){
                    alert(i18n.language === "fr" ? "Veuillez remplir tous les champs" : "Please fill all fields")
                    return
                }

                _projets[i].validated = true
            }
        }
        props.setProjets(_projets)
    }

    function onFieldChange(e){
        let projId = e.target.name.split("_")[1]
        let field = e.target.name.split("_")[0]
        let _projets = [...props.projets]
        for(let i=0;i<_projets.length;i++){
            if(_projets[i]._id === projId){
                if(field === "confidential"){
                    _projets[i].confidential = e.target.value === "true"
                } else {
                    _projets[i][field] = e.target.value
                }
            }
        }
        props.setProjets(_projets)
    }

    // console.log("props.projets")
    // console.log(props.projets)

    return (
        <div>
            <br/>
            {props.projets && props.projets.map((projet,i) =>
                <ProjectContainer key={projet._id} style={ projet.validated ? {borderColor:"rgb(144, 221, 144)"} : {}}>
                   <h3 className='blacklower'>{i18n.language === "fr" ? "Projet " : "Project "}{i + 1}</h3><br/>
                    <label>
                        {i18n.language === "fr" ? "Nom du projet*" : "Name of project*"}<br/>
                        <input disabled={projet.validated} type="text" name={"title_"+projet._id} placeholder={i18n.language === "fr" ? "Titre" : "Title"} defaultValue={projet.title} onChange={onFieldChange}/>
                    </label>
                    <label>
                        {i18n.language === "fr" ? "Type de projet*" : "Type of project*"}<br/>
                        <input disabled={projet.validated} type="text" name={"type_"+projet._id} placeholder={i18n.language === "fr" ? "Type" : "Type"} defaultValue={projet.type} onChange={onFieldChange}/>
                    </label>
                    <label>
                        {i18n.language === "fr" ? "Pays du projet*" : "Country of project*"}<br/>
                        <input disabled={projet.validated} type="text" name={"country_"+projet._id} placeholder={i18n.language === "fr" ? "Pays" : "Country"} defaultValue={projet.country} onChange={onFieldChange}/>
                    </label>
                    <label>
                        {i18n.language === "fr" ? "Ville du projet*" : "City of project*"}<br/>
                        <input disabled={projet.validated} type="text" name={"city_"+projet._id} placeholder={i18n.language === "fr" ? "Ville" : "City"} defaultValue={projet.city} onChange={onFieldChange}/>
                    </label>
                    {projet.validated ?
                        <div className='announcement green'>{i18n.language === "fr" ? "✓  Projet validé" : "✓  Project validated"}</div>
                    :
                        <button style={{float:"left"}} className='dualbuttons' onClick={(e)=>validateProject(e,projet._id)}>{i18n.language === "fr" ? "Confirmer" : "Confirm"}</button>
                    }
                    <button style={{float:"right"}} className='red_button dualbuttons' onClick={(e)=>removeProjet(e,projet._id)}>{i18n.language === "fr" ? "Supprimer" : "Delete"}</button>
                    <br/>
                </ProjectContainer>
            )}
            {!props.projets.find(proj => !proj.validated) && <button className='centered' onClick={addProjet}>{i18n.language === "fr" ? "+ Ajouter un projet" : "+ Add a project"}</button>}
            <br/>
        </div>
    );
};

export default BesoinEditor;